export default function QuestionsIntroComponent() {
  return (
    <div className=" items-center  absolute justify-center flex  h-screen w-screen top-0 z-[-20] ">
      {/* <img
        className="   h-screen w-screen z-[-99] object-cover"
        src="/questions-intro.png"
        alt=""
      /> */}
    </div>
  );
}
